import { Button, Toolbar } from '@treams/treams-ui';

import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';

import ConversationItem from './ConversationItem';

import LayoutSection from './layout/LayoutSection';
import { ChevronLeftIcon } from '@treams/treams-icons';
import ConversationSidebar from './sidebar/Sidebar';
import ConversationCallout from './ConversationCallout';
import ConversationFooter from './ConversationFooter';
import ConversationSection from './layout/ConversationSection';
import useDetectPrint from '../hooks/useDetectPrint';

export default function Conversation({
	conversation,
	returnUrl,
}: {
	conversation: graphql.Conversation;
	returnUrl?: string;
}) {
	const isPrinting = useDetectPrint();

	const { t } = useTranslation();

	return (
		<>
			{!isPrinting && (
				<>
					<ConversationSidebar conversation={conversation} />
					<LayoutSection>
						<Toolbar mb={30}>
							<Button
								icon={<ChevronLeftIcon />}
								link={returnUrl}
								title={t('goals.show.toolbar.back')}
								type="secondary"
							/>
						</Toolbar>
					</LayoutSection>
					<LayoutSection>
						<ConversationCallout conversation={conversation} />
					</LayoutSection>
				</>
			)}

			<LayoutSection>
				{conversation.sections.map((section, sectionIndex) => (
					<ConversationSection key={sectionIndex} mb={4}>
						{section.items.map((item, index) => (
							<ConversationItem key={index} item={item} participants={conversation.participants} />
						))}
					</ConversationSection>
				))}
			</LayoutSection>
			{!isPrinting && <ConversationFooter conversation={conversation} />}
		</>
	);
}
